<template lang="pug">
	.creative--revisions.flex-row.space.wrap(v-if="creative")
		DxDropDownButton(
			v-if="supportedLanguages.length > 1",
			:text="currentLanguage.text",
			:split-button="false",
			:dropDownOptions="{ width: '300px' }",
			:use-select-mode="false",
			ref="languagesDropdown",
			:hoverStateEnabled="false",
			:focusStateEnabled="false",
			:selectedItemKey="null",
			:items="revisionDropDownItems")
			template(v-slot:revisionsTemplate="{ data }")
				.click(@click.stop, :title="$tCaption('Languages')")
					ListView.full-width(ref="languagesList", :topPagerVisible="false", :showColumnHeaders="false", initialView="table", :columns="languagesColumns",
						:width="480", :height="300", :searchVisible="false", :hideViewsSelection="true", :getTotal="(r) => r.length",
						:getItems="(r) => r", :getData="() => supportedLanguages")
						.flex-row.space.align-center(slot="left-actions")
							span {{$tCaption('Languages')}}
							DxButton(icon="plus", :hint="$tCaption('Add language')", @click="e => { e.event.stopPropagation(); showNewLanguagePopup(); }")
						template(v-slot:displayValue="{ data }")
							.flex-row.space.justify.align-center.creative--revisions
								.flex-row.space.grey.align-center
									i.fas.fa-angle-right(v-if="data.locale === currentLanguage.locale")
									a.revision-name(@click="() => openLanguageRevision(data)") {{data.text}}
		DxDropDownButton(
			v-if="creative.IsPublished || otherRevisions.length",
			:text="getRevisionText(revisionNumber)",
			:split-button="false",
			:dropDownOptions="{ width: '300px' }",
			:use-select-mode="false",
			ref="revisionsDropdown",
			:hoverStateEnabled="false",
			:focusStateEnabled="false",
			:selectedItemKey="null",
			:items="revisionDropDownItems")
			template(v-slot:revisionsTemplate="{ data }")
				.click(@click.stop, :title="$tCaption('Revisions')")
					ListView.full-width(ref="revisionsList", :topPagerVisible="false", :showColumnHeaders="false", initialView="table", :columns="revisionsColumns",
						:width="480", :height="300", :searchVisible="false", :hideViewsSelection="true", :getTotal="(r) => revisions.length",
						:getItems="(r) => r", :getData="() => revisions", :pageSize="revisions.length")
						.flex-row.space.align-center(slot="left-actions")
							span {{$tCaption('Revisions')}}
							DxButton(v-if="creative.IsPublished", icon="plus", :hint="$tCaption('New revision')", @click="showNewRevisionPopup")
						template(v-slot:displayValue="{ data }")
							.flex-row.space.justify.align-center
								.flex-row.space.grey.align-center.creative--revisions
									i.fas.fa-angle-right(v-if="data.CreativeId === creativeId")
									a.revision-name(@click="() => openRevision(data)") {{data.Name !== getRevisionText(data.RevisionNumber) ? `${data.Name} (${getRevisionText(data.RevisionNumber)})` : data.Name}}
									span(v-if="data.IsActiveRevision") {{$tCaption('active')}}
								.flex-row.space
									DxButton(v-if="data.CreativeId !== rootCreativeId", icon="remove", type="normal", @click="removeRevision(data)")
		DxButton(v-if="!creative.IsActiveRevision && creative.IsPublished", :text="$tCaption('Set active')", @click="setActiveRevision")
		Popup(v-if="newRevisionPopup", :popupVisible="newRevisionPopup", :width="380", :height="250", :title="$tCaption('New revision')", :closeOnOutsideClick="false", @hiding="newRevisionPopup = false")
			.flex-col.space-medium
				DxTextBox(:value.sync="newRevisionName", :placeholder="$tCaption('Revision name')", valueChangeEvent="keyup")
				DxCheckBox(v-if="creative.__totalSubInsertions", :value.sync="copySubTracks", :text="$tCaption('Copy sub tracks')")
			template(slot="actions-right")
				DxButton(:text="$tCaption('OK', '@actions')", type="default", @click="() => createRevision()", :disabled="!newRevisionName || !!isLoading")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="newRevisionPopup = false")
		Popup(v-if="newLanguagePopup", :popupVisible="newLanguagePopup", :width="380", :height="270", :title="$tCaption('Add language')", :closeOnOutsideClick="false", @hiding="newLanguagePopup = false")
			.flex-col.space-medium
				SelectBox(:dataSource="languages", :showClearButton="true", :value.sync="newLanguageCode", :placeholder="$tCaption('Language')", :searchEnabled="true", displayExpr="text", valueExpr="locale")
				DxCheckBox(v-if="hasTranslator", :value.sync="translate", :text="$tCaption('Translate')")
				DxCheckBox(v-if="hasAiTranslationEnhancement", :value.sync="enhance", :text="$tCaption('AI Translate Enhancements')")
			template(slot="actions-right")
				DxButton(:text="$tCaption('OK', '@actions')", type="default", @click="() => createLanguageRevision()", :disabled="!newLanguageCode || !!isLoading")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="newLanguagePopup = false")
</template>
<script>
	import _ from 'lodash';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import ListView from 'app-core/ListView.vue';	
	import DxButton from 'devextreme-vue/button';
	import Popup from 'app-core/Popup.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import SelectBox from 'devextreme-vue/select-box';
	import cognitiveArrays from 'view/insertion/cognitive-arrays';

	export default {
		translationCategory: 'creative.CreativeRevisions',
		name: 'creative--revisions',
		components: {
			DxDropDownButton,
			ListView,
			DxButton,
			Popup,
			DxTextBox,
			SelectBox,
			DxCheckBox
		},
		mixins: [cognitiveArrays],
		props: ['creative'],
		data() {
			return {
				revisions: [],
				revisionDropDownItems: [{ template: 'revisionsTemplate' }],
				revisionsColumns: [{ dataField: 'Name', cellTemplate: 'displayValue' }],
				newRevisionName: null,
				newRevisionPopup: false,
				languagesColumns: [{ dataField: 'text', cellTemplate: 'displayValue' }],
				newLanguagePopup: false,
				newLanguageCode: null,
				isLoading: 0,
				selectedLanguageCode: null,
				copySubTracks: !!this.creative.__totalSubInsertions,
				speechProfile: null,
				translate: false,
				enhance: false
			}
		},
		computed: {
			revisionNumber() {
				return this.creative?.RevisionNumber;
			},
			creativeId() {
				return this.creative?.Oid;
			},
			otherRevisions() {
				return (this.revisions || []).filter(f => f.CreativeId !== this.creative?.Oid);
			},
			supportedLanguages() {
				var langs = `${this.creative.AllSupportedLanguages || 'en-US'}`.split(',');
				return (this.languages || []).filter(f => langs.some(v => `${v}`.trim() === f.locale));
			},
			currentLanguage() {
				return this.supportedLanguages.filter(f => f.locale === (this.selectedLanguageCode || this.languageCode))[0] || { locale: this.languageCode, text: this.languageCode };
			},
			rootCreativeId() {
				return this.creative?.RootCreativeId || this.creative?.Oid;
			},
			languageCode() {
				return this.creative.LanguageCode || 'en-US';
			},
			hasTranslator() {
				return !!this.speechProfile?.TranslatorProvider;
			},
			hasAiTranslationEnhancement() {
				return !!this.speechProfile?.AiScriptGenerator;
			},
		},
		watch: {
			'creative.Oid'() {
				this.loadRevisions(true);
			},
			currentLanguage() {
				this.loadRevisions(true);
			},
			revisions() {
				this.$refs.revisionsList?.reload();
			},
			'creative.IsPublished'() {
				this.loadRevisions();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.revisions = this;
			this.loadRevisions();
			this.loadSpeechProfile();
		},
		methods: {
			async loadSpeechProfile() {
				this.speechProfile = await this.$Data.getExternalApi('SpeechProcessingProfile/Get', 'code=SsmlTranslator');
			},
			getRevisionText(number) {
				return this.$tCaption('Revision <NUMBER>').replace('<NUMBER>', number);
			},
			showNewRevisionPopup() {
				this.newRevisionPopup = false;
				this.newRevisionName = this.creative?.RootCreativeName || (this.$tCaption('Revision') + ` ${(this.creative?.RevisionNumber || 0) + 1}`);
				this.copySubTracks = true;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.newRevisionPopup = true;
				})
			},
			showNewLanguagePopup() {
				this.newLanguagePopup = false;
				this.newLanguageCode = null;
				this.translate = this.hasTranslator;
				this.enhance = this.hasAiTranslationEnhancement;
				setTimeout(() => {
					if (this._isDestroyed) return;
					this.newLanguagePopup = true;
				}, 100);
			},
			loadRevisions(clear) {
				if (clear)
					this.revisions = [];
				return this.getCreativeRevisions(this.currentLanguage?.locale).then(r => {
					this.revisions = r || [];
				});
			},
			getCreativeRevisions(languageCode) {
				return this.$Data.getExternalApi('CreativeRevise/GetAllRevisions', `creativeId=${this.rootCreativeId}&languageCode=${languageCode}`);
			},
			createRevision() {
				this.isLoading++;
				this.$notifyMessage(this.$tCaption('Starting new revision'), { busy: true })
				return this.$Data.postExternalApi('CreativeRevise/Revise', { CreativeId: this.creativeId, RevisionName: this.newRevisionName, CopySubTracks: this.copySubTracks }).then(r => {
					if (r.Success !== false) {
						this.$router.push({ path: `/creative/Detail/${r.Data.Oid}` });
					}
				}).finally(() => {
					this.newRevisionPopup = false;
					this.isLoading--;
				});
			},
			createLanguageRevision() {
				this.isLoading++;
				return this.$Data.postExternalApi('CreativeRevise/NewLanguage', { 
					CreativeId: this.creativeId,
					LanguageCode: this.newLanguageCode,
					AutoTranslate: this.translate,
					AiTranslationEnhancement: this.enhance
				}).then(r => {
					if (r.Success !== false) {
						this.$notifyMessage(this.$tCaption('Language has been successfully created'));
						this.$router.push({ path: `/creative/Detail/${r.Data.Oid}` });
					}
				}).finally(() => {
					this.isLoading--;
					this.newLanguagePopup = false;
				});
			},
			removeRevision(revision) {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to delete the selected revision?'),
					handler: () => {
						this.$Data.getExternalApi('Creative/DeleteCreative', `creativeId=${revision.CreativeId}`).then(r => {
							if (r.Success !== false) {
								this.$notifySuccess(this.$tCaption('Revision has been removed'));
								let lastRevisionId = _.last((this.revisions || []).filter(f => f.CreativeId !== this.creative?.Oid))?.CreativeId || this.creative.RootCreativeId;
								this.$router.push({ path: `/creative/Detail/${lastRevisionId}` });
							}
						})
					}
				});
				
			},
			openRevision(revision) {
				this.$router.push({ path: `/creative/Detail/${revision.CreativeId}` });
			},
			getLangLastRevision(locale) {
				return (this.$Data.getRevisionsFromString(this.creative.RootLastRevisionIds) || []).filter(f => f.languageCode === locale)[0];
			},
			openLanguageRevision(lang) {
				var lastCreativeId = this.getLangLastRevision(lang.locale)?.creativeId;
				if (lastCreativeId) {
					this.selectedLanguageCode = lang?.locale;
					this.$router.push({ path: `/creative/Detail/${lastCreativeId}` });
				}
			},
			setActiveRevision() {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to make current revision active?'),
					handler: () => {
						this.$Data.getExternalApi('CreativeRevise/SetRevisionActive', `creativeId=${this.creative?.Oid}`).then(r => {
							if (r.Success !== false) {
								this.$notifySuccess(this.$tCaption('Revision has been set as active'));
								this.creative.IsActiveRevision = true;
								this.loadRevisions();
							}
						})
					}
				});
			}
		}
	};
</script>
<style lang="scss">
	.creative--revisions {
		.revision-name {
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 160px;
		}
	}
</style>